import e63w212Preview from '~/assets/images/vehiclePreviews/e63w212.png';

interface IVehiclePreviewProps
	extends React.DetailedHTMLProps<
		React.ImgHTMLAttributes<HTMLImageElement>,
		HTMLImageElement
	> {
	model: string;
}

interface IAvailablePreviews {
	[model: string]: string;
}

const availablePreviews: IAvailablePreviews = {
	e63w212: e63w212Preview,
};

const VehiclePreview = ({ model, ...props }: IVehiclePreviewProps) => {
	return <img src={availablePreviews[model]} {...props}></img>;
};

export { VehiclePreview };
